import { render } from "./FiveCircleBookIntroduction.vue?vue&type=template&id=887bfef6"
const script = {}

import "./FiveCircleBookIntroduction.vue?vue&type=style&index=0&id=887bfef6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__